import { makeAutoObservable } from 'mobx';
import { DATA } from './data';
import { niceRounding } from './helpers';
import { POPUP } from './popupManager';

export const MAX_OFFLINE_HOURS = 4;

class OfflineIncome {
  public data: { money: number; errorCode: 'no-managers' | 'not-enough-time' | 'too-much-time-offline' | null } | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  calculate(lastOnline: Date) {
    if (window.location.href.includes('disable_offline_income=true')) {
      return;
    }

    let offlineMinutes = Math.floor((new Date().getTime() - lastOnline.getTime()) / 1000 / 60);
    //let offlineMinutes = 50000;

    if (offlineMinutes < 1) {
      this.data = { money: 0, errorCode: 'not-enough-time' };
      return;
    }

    if (DATA.managers.length === 0) {
      this.data = { money: 0, errorCode: 'no-managers' };
      return;
    }

    this.data = { money: 0, errorCode: null };

    if (offlineMinutes > MAX_OFFLINE_HOURS * 60) {
      offlineMinutes = MAX_OFFLINE_HOURS * 60;
      this.data.errorCode = 'too-much-time-offline';
    }

    const offlineSeconds = offlineMinutes * 60;

    // calculate how many passengers in total arrive during offline time, don't care if airport is full
    let totalPassengers = 0;
    DATA.airports
      .filter((a) => a.isAvailable)
      .forEach((airport) => {
        totalPassengers += airport.getUpgradeValue('arrival_speed') * offlineSeconds;
      });

    // calculate total transport capacity from all airplanes, assume there is a big airplane with that capacity
    let transportCapacity = 0;
    DATA.airplanes.forEach((airplane) => {
      transportCapacity += airplane.getUpgradeValue('capacity');
    });

    // based on how many managers you have, calculate how often would that airplane fly
    const averageManagerDelay = DATA.managers.reduce((acc, m) => acc + m.getUpgradeValue('airplanes_per_second'), 0) / DATA.managers.length;

    // assume that big airplane in best case scenario will make courses every 20 seconds
    // but multiply this by how fast are your managers on average, thus the transportCapacity will happen every 20..40 seconds
    const flightDelay = 30 * (2 - averageManagerDelay);

    const transportedPassengers = Math.min(totalPassengers, transportCapacity * (offlineSeconds / flightDelay));

    const averageLoungeTicketPrice =
      DATA.lounges.length === 0 ? 0 : DATA.lounges.reduce((acc, l) => acc + l.getUpgradeValue('ticket_price'), 0) / DATA.lounges.length;
    const averageLoungeChance =
      DATA.lounges.length === 0 ? 0 : DATA.lounges.reduce((acc, l) => acc + l.getUpgradeValue('chance'), 0) / DATA.lounges.length;
    const averageAirplaneTicketPrice =
      DATA.airplanes.reduce((acc, a) => acc + a.getUpgradeValue('ticket_price'), 0) / DATA.airplanes.length;

    // TODO take into account the average ticket price multiplier from airport and managers

    const airplanesIncome = transportedPassengers * averageAirplaneTicketPrice;
    const loungeIncome = transportedPassengers * averageLoungeTicketPrice * averageLoungeChance;
    const money = airplanesIncome + loungeIncome;

    this.data.money = niceRounding(money);

    console.log('Offline minutes:', offlineMinutes);
    console.log('Total passengers:', totalPassengers);
    console.log('Average manager delay:', averageManagerDelay);
    console.log('Flight delay:', flightDelay);
    console.log('Average lounge ticket price:', averageLoungeTicketPrice);
    console.log('Average lounge chance:', averageLoungeChance);
    console.log('Average airplane ticket price:', averageAirplaneTicketPrice);
    console.log('Transported passengers:', transportedPassengers);
    console.log('Airplanes income:', airplanesIncome);
    console.log('Lounge income:', loungeIncome);
    console.log('Total income:', money);
  }

  collect(isX2: boolean) {
    if (isX2) {
      this.data!.money *= 2;
    }

    DATA.addMoney(this.data!.money);
    DATA.save();
    POPUP.showOfflineIncomeCollect(this.data!.money, isX2);
    this.clear();
  }

  clear() {
    this.data = null;
  }
}

export const OFFLINE_INCOME = new OfflineIncome();
